import React from 'react';
import { Info, AlertTriangle } from 'lucide-react';

// Messaggio di sistema con icona (mai corsivo sciolto)
export function DrawerCallout({
  children,
  tone = 'info',
}: {
  children: React.ReactNode;
  tone?: 'info' | 'warning';
}): JSX.Element {
  const Icon = tone === 'warning' ? AlertTriangle : Info;

  return (
    <div className="flex gap-2 rounded-md border border-[rgba(55,53,47,0.09)] dark:border-[#3F4447] bg-[#F7F7F5] dark:bg-[#373C3F] px-2.5 py-2 text-xs text-[#37352F] dark:text-white">
      <Icon className="h-3.5 w-3.5 mt-0.5 shrink-0 text-[#787774] dark:text-gray-400" strokeWidth={1.5} />
      <div>{children}</div>
    </div>
  );
}
